import { UserDto } from "../types/user.dto";
import action from "./../helpers/rest-client";

export class ErrorUser extends Error {}

class UserService {
  public getUserInformation() {
    const user: UserDto = JSON.parse(localStorage.getItem("user") || "{}");
    return { ...user };
  }

  public async updateUserInformation(payload) {
    return action
      .Patch({
        url: `/profile`,
        body: payload,
      })
      .then((resp) => {
        const userStored = localStorage.getItem("user");

        localStorage.setItem(
          "user",
          JSON.stringify({
            ...JSON.parse(userStored || "{}"),
            ...resp?.success?.result,
          })
        );

        return resp;
      })
      .catch((error) => {
        throw new ErrorUser(error.message);
      });
  }

  public async getUserProfile() {
    return action
      .Get({
        url: "/profile",
      })
      .then((resp) => {
        return resp;
      })
      .catch((error) => {
        throw new ErrorUser(error.message);
      });
  }

  public async changePassword(payload) {
    const { encryptPayload } = await import("../utils/encryption");
    const encrypted = await encryptPayload(payload);
    const body = encrypted ? { payload: encrypted } : payload;

    return action
      .Patch({
        url: `/profile/psw/`,
        body,
      })
      .then((resp) => {
        return resp;
      })
      .catch((error) => {
        // Extract error information from axios error structure
        const errorData = error.response?.data || {};
        const message = errorData.message || error.message || "Error al cambiar contraseña";

        throw Object.assign(new ErrorUser(message), {
          message,
          httpCode: error.response?.status || 400,
        });
      });
  }
}

const user = new UserService();
export default user;
